'use client'

import { ReactNode } from 'react'
import { TopBar } from './top-bar'
import { ContextBar } from './context-bar'
import { usePathname } from 'next/navigation'

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  const pathname = usePathname()
  // Show ContextBar only on chat and genesis pages
  const showContextBar = pathname === '/chat' || pathname === '/genesis' || pathname === '/schedule'

  return (
    <div className="flex h-screen flex-col bg-background text-foreground overflow-hidden">
      <TopBar />
      <div className="flex flex-1 overflow-hidden relative">
        {showContextBar && <ContextBar />}
        <main className="flex-1 overflow-hidden">{children}</main>
      </div>
    </div>
  )
}
